import { API } from "../../../utils";

export const getStripeConnectListApi = async () => {
    const res = await API.get("stripe/connect/stores");
    return res.data;
};

export const connectStripeAccountApi = async (storeId, redirect_url) => {
    const res = await API.get(`stripe/connect?store_id=${storeId}&redirect_url=${redirect_url}`);
    return res.data;
};
export const disconnectStripeAccountApi = async (acID, storeId) => {
    const res = await API.get(`stripe/dis-connect?stripe_account_id=${acID}&store_id=${storeId}`);
    return res.data;
};

export const getStripeConnectVerifyApi = async (scope, code, state) => {
    let url = `stripe/callback?scope=${scope}&code=${code}&state=${state}`
    const res = await API.get(url);
    return res.data;
};

export const getStripeConnectDetailApi = async (storeId) => {
    const res = await API.get(`stripe/connect/stores/${storeId}`);
    return res.data;
};